// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9833d6de","453":"90e197e9","732":"9255c7c6"}[chunkId] + ".chunk.js";
};